(function(){
  'use strict';
  function ensureStyles(){if(!document.querySelector('link[href*="bundle-builder.css"]')){var sc=document.querySelector('script[src*="bundle-builder.js"]');if(sc){var l=document.createElement('link');l.rel='stylesheet';l.href=sc.src.replace(/bundle-builder\.js(\?.*)?$/,'bundle-builder.css');document.head.appendChild(l);}}}
  ensureStyles();
  if(window.BundleBuilderLoaded)return;
  window.BundleBuilderLoaded=true;

  var DEFAULT_EXCLUDE_HANDLES=['anime-symbol-tattoo-sheet','anime-symbol-tattoo-sheet-free-gift'];
  var DEFAULT_EXCLUDE_TAGS=['free-gift','hidden','promo-auto-add'];

  var cfg=window.BundleBuilderConfig||{tiers:[{buy:3,free:1,saveLabel:'SAVE £6.99',savePence:699,popular:false},{buy:6,free:2,saveLabel:'SAVE £13.98',savePence:1398,popular:true},{buy:9,free:3,saveLabel:'SAVE £20.97',savePence:2097,popular:false}],tabs:[{label:'ALL',handle:'all'},{label:'SMALL',handle:'small'},{label:'MEDIUM',handle:'medium'},{label:'LARGE',handle:'large'},{label:'SHEETS',handle:'sheets'},{label:'FOR HER',handle:'for-her'}]};

  var excludeHandles=(cfg.excludeHandles&&cfg.excludeHandles.length?cfg.excludeHandles:DEFAULT_EXCLUDE_HANDLES).map(function(h){return String(h).toLowerCase();});
  var excludeTags=(cfg.excludeTags&&cfg.excludeTags.length?cfg.excludeTags:DEFAULT_EXCLUDE_TAGS).map(function(t){return String(t).toLowerCase();});

  var sel={},cache={},activeHandle=(cfg.tabs[0]||{}).handle||'all';

  function paidQty(){return Object.values(sel).filter(function(v){return !v.free;}).length;}
  function freeQty(){return Object.values(sel).filter(function(v){return v.free;}).length;}
  function freeAllowed(){var p=paidQty();return p>=9?3:p>=6?2:p>=3?1:0;}
  function totalPence(){return Object.values(sel).reduce(function(s,v){return s+(v.free?0:v.price);},0);}

  /* ---------------------------------------------------------------
   * Money
   * ---------------------------------------------------------------
   * The builder deliberately does NO currency selection or conversion.
   *
   * Prices are rendered in the shop's BASE currency using the shop's own
   * money_format, then wrapped in .money — the hook the BUCKS currency
   * converter scans for. BUCKS is the single source of truth for what the
   * shopper sees, so the builder always agrees with the switcher.
   *
   * Previously this formatted using Shopify.currency.active. With Shopify
   * Markets enabled that can resolve to a different currency than the one
   * BUCKS is displaying, which is how the modal ended up showing EUR while
   * the switcher read GBP. Two sources of truth — never again.
   *
   * It also omits data-si-gbp, so assets/si-currency.js (which guesses from
   * navigator.language) leaves these prices alone.
   */
  function moneyNumber(cents,precision,thousands,decimal){
    if(isNaN(cents)||cents===null)cents=0;
    var value=(cents/100).toFixed(precision);
    var parts=value.split('.');
    var intPart=parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+thousands);
    return intPart+(parts[1]?decimal+parts[1]:'');
  }

  function formatMoney(cents){
    var f=(window.SwiftInkMoney&&window.SwiftInkMoney.format)||'\u00a3{{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g,function(_,name){
      switch(name){
        case 'amount_no_decimals': return moneyNumber(cents,0,',','.');
        case 'amount_with_comma_separator': return moneyNumber(cents,2,'.',',');
        case 'amount_no_decimals_with_comma_separator': return moneyNumber(cents,0,'.',',');
        case 'amount_with_space_separator': return moneyNumber(cents,2,' ',',');
        case 'amount_no_decimals_with_space_separator': return moneyNumber(cents,0,' ',',');
        case 'amount_with_apostrophe_separator': return moneyNumber(cents,2,"'",'.');
        default: return moneyNumber(cents,2,',','.');
      }
    });
  }

  function fmt(pence){
    return '<span class="money">'+formatMoney(pence)+'</span>';
  }

  /* BUCKS watches the DOM, but nudge it after we inject prices in case it
     misses nodes added long after page load. All calls are guarded. */
  function nudgeCurrencyApp(){
    try{
      if(window.BUCKS){
        if(typeof window.BUCKS.convertAll==='function'){window.BUCKS.convertAll();}
        else if(typeof window.BUCKS.refresh==='function'){window.BUCKS.refresh();}
        else if(typeof window.BUCKS.init==='function'){window.BUCKS.init();}
      }
      document.dispatchEvent(new CustomEvent('bucks:refresh',{bubbles:true}));
      document.dispatchEvent(new CustomEvent('currency:refresh',{bubbles:true}));
    }catch(e){}
  }

  function fmtSave(tier){
    /* savePence is in GBP; SILocalMoney (snippets/si-local-money.liquid) turns it into the
       visitor's currency at Shopify's rate and rounding. Absent on the UK site. */
    if(tier&&tier.savePence&&window.SILocalMoney)return 'SAVE '+window.SILocalMoney.convert(tier.savePence/100);
    if(tier&&tier.savePence)return 'SAVE '+fmt(tier.savePence);
    return (tier&&tier.saveLabel)||'';
  }

  function giftSVG(){return '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:5px;position:relative;top:-1px"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M16.5 8a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';}

  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}

  function isExcluded(product){
    var handle=String(product.handle||'').toLowerCase();
    if(excludeHandles.indexOf(handle)!==-1)return true;
    var tags=product.tags||[];
    for(var i=0;i<tags.length;i++){
      if(excludeTags.indexOf(String(tags[i]).toLowerCase().trim())!==-1)return true;
    }
    return false;
  }

  function isSoldOut(product){
    var vs=product.variants||[];
    for(var i=0;i<vs.length;i++){
      if(vs[i].available!==false)return false;
    }
    return true;
  }

  function recalcCheapestFree(){
    var allVids=Object.keys(sel);
    var freeCount=allVids.filter(function(v){return sel[v].free;}).length;
    if(freeCount===0)return;
    allVids.sort(function(a,b){return sel[a].price-sel[b].price;});
    allVids.forEach(function(vid,idx){sel[vid].free=(idx<freeCount);});
  }

  function toggleItem(vid,pricePence){
    if(sel[vid]){
      var wasFree=sel[vid].free;
      delete sel[vid];
      if(!wasFree){
        var newFa=freeAllowed();
        var freeVids=Object.keys(sel).filter(function(v){return sel[v].free;});
        freeVids.slice(newFa).forEach(function(v){delete sel[v];});
      }
    } else {
      var fa=freeAllowed(),fq=freeQty();
      sel[vid]={qty:1,free:fa>fq,price:pricePence};
    }
    recalcCheapestFree();
    refreshProgress();
    refreshCards();
    nudgeCurrencyApp();
  }

  function getSize(pid){var meta=window.BundleBuilderProductMeta&&window.BundleBuilderProductMeta[pid];return(meta&&meta.size)||'';}

  function cardHTML(product){
    var v=product.variants[0],pence=Math.round(parseFloat(v.price)*100);
    var img=(product.images&&product.images[0])?product.images[0].src:'';
    var soldOut=isSoldOut(product);
    var inSel=sel[v.id],isPaid=!soldOut&&inSel&&!inSel.free,isFree=!soldOut&&inSel&&inSel.free;
    var cls='si-bb-card'+(isPaid?' has-qty':'')+(isFree?' is-free':'')+(soldOut?' is-soldout':'');
    var badge=soldOut?'':isPaid?'✓':isFree?'FREE':'';
    var priceHTML=soldOut?'<span class="si-bb-soldout-label">Sold out</span>':(isFree?('<s>'+fmt(pence)+'</s> <span class="si-bb-free-label">FREE</span>'):fmt(pence));
    var size=getSize(product.id);
    return '<div class="'+cls+'" data-vid="'+v.id+'" data-pence="'+pence+'" data-pid="'+product.id+'"'+(soldOut?' data-soldout="1" aria-disabled="true"':' role="button" tabindex="0"')+'>'+
      '<div class="si-bb-card-img">'+
      (img?'<img src="'+img+'" alt="" loading="lazy">':'<div class="si-bb-card-placeholder"></div>')+
      (soldOut?'<div class="si-bb-soldout-flag">SOLD OUT</div>':'')+
      '<div class="si-bb-count-badge">'+badge+'</div>'+
      '</div>'+
      '<div class="si-bb-card-info">'+
      (size?'<div class="si-bb-card-size">'+esc(size)+'</div>':'')+
      '<div class="si-bb-card-name">'+esc(product.title)+'</div>'+
      '<div class="si-bb-card-price">'+priceHTML+'</div>'+
      '</div></div>';
  }

  function refreshCards(){
    document.querySelectorAll('.si-bb-card').forEach(function(card){
      if(card.dataset.soldout==='1')return;
      var vid=card.dataset.vid,inSel=sel[vid];
      var isPaid=inSel&&!inSel.free,isFree=inSel&&inSel.free;
      card.classList.toggle('has-qty',!!isPaid);
      card.classList.toggle('is-free',!!isFree);
      var badge=card.querySelector('.si-bb-count-badge');
      if(badge)badge.textContent=isPaid?'✓':isFree?'FREE':'';
      var priceEl=card.querySelector('.si-bb-card-price');
      if(priceEl){
        var pence=parseInt(card.dataset.pence,10);
        if(isFree){priceEl.innerHTML='<s>'+fmt(pence)+'</s> <span class="si-bb-free-label">FREE</span>';}
        else{priceEl.innerHTML=fmt(pence);}
      }
    });
  }

  function loadProducts(handle){
    var grid=document.getElementById('si-bb-grid');if(!grid)return;
    function render(list){
      grid.innerHTML=list.length?list.map(cardHTML).join(''):'<div class="si-bb-loading">No products found.</div>';
      nudgeCurrencyApp();
    }
    if(cache[handle]){render(cache[handle]);return;}
    grid.innerHTML='<div class="si-bb-loading">Loading…</div>';
    fetch('/collections/'+handle+'/products.json?limit=250')
      .then(function(r){return r.json();})
      .then(function(d){
        var list=(d.products||[]).filter(function(p){return !isExcluded(p);});
        cache[handle]=list;
        render(list);
      })
      .catch(function(){grid.innerHTML='<div class="si-bb-loading">Failed to load.</div>';});
  }

  function refreshProgress(){
    var pq=paidQty(),fq=freeQty(),fa=freeAllowed();
    var pendingFree=fa>fq,canCheckout=fa>0&&fq>=fa;
    var fill=document.getElementById('si-bb-fill'),track=fill&&fill.closest('.si-bb-progress-track');
    var ptl=document.getElementById('si-bb-ptl'),ptr=document.getElementById('si-bb-ptr');
    var prow=document.getElementById('si-bb-prow'),ptotal=document.getElementById('si-bb-ptotal'),psave=document.getElementById('si-bb-psave');
    var strip=document.getElementById('si-bb-strip'),stext=document.getElementById('si-bb-stext'),sprice=document.getElementById('si-bb-sprice');
    var addBtn=document.getElementById('si-bb-add');
    var pct=0,complete=false;

    if(pq===0&&fq===0){
      pct=0;
      if(ptl)ptl.textContent='Pick 3 items to unlock 1 FREE';
      if(ptr)ptr.textContent='';
      if(prow)prow.style.display='none';
      if(strip)strip.style.display='none';
    } else if(pendingFree){
      var needFree=fa-fq;
      pct=100;
      if(ptl)ptl.textContent=pq+' item'+(pq>1?'s':'')+' in bundle';
      if(ptr)ptr.textContent='Add '+needFree+' item'+(needFree>1?'s':'')+' FREE!';
      if(prow){prow.style.display='';if(ptotal)ptotal.innerHTML='Total '+fmt(totalPence());if(psave)psave.textContent=needFree+' FREE item'+(needFree>1?'s':'')+' to add!';}
      if(strip){strip.style.display='';if(stext)stext.textContent=pq+' PAID · ADD '+needFree+' FREE';if(sprice)sprice.innerHTML=fmt(totalPence());}
    } else if(canCheckout){
      var hitT=null;cfg.tiers.forEach(function(t){if(pq>=t.buy)hitT=t;});
      var nextT=cfg.tiers.find(function(t){return pq<t.buy;})||null;
      if(!nextT){pct=100;complete=true;}
      else{var prevBuy=hitT?hitT.buy:0;pct=Math.max(5,Math.min(((pq-prevBuy)/(nextT.buy-prevBuy))*100,99));}
      if(ptl)ptl.textContent=pq+' paid · '+fq+' FREE';
      if(ptr)ptr.textContent=nextT?('Add '+(nextT.buy-pq)+' more for '+(nextT.free-fq)+' more FREE'):(hitT.free+' item'+(hitT.free>1?'s':'')+' FREE at checkout!');
      if(prow){prow.style.display='';if(ptotal)ptotal.innerHTML='Total '+fmt(totalPence());if(psave)psave.innerHTML=hitT?fmtSave(hitT):'';}
      if(strip){strip.style.display='';if(stext)stext.textContent='BUNDLE COMPLETE'+(nextT?' · ADD MORE FOR BIGGER SAVING':'');if(sprice)sprice.innerHTML=fmt(totalPence())+(hitT?' · '+fmtSave(hitT):'');}
    } else {
      var t1=cfg.tiers[0],need=t1.buy-pq;
      pct=Math.min((pq/t1.buy)*100,99);
      if(ptl)ptl.textContent=pq+' of '+t1.buy+' picked';
      if(ptr)ptr.textContent=need+' more to unlock 1 FREE';
      if(prow){prow.style.display='';if(ptotal)ptotal.innerHTML='Total '+fmt(totalPence());if(psave)psave.textContent='Pick '+need+' more to unlock FREE';}
      if(strip){strip.style.display='';if(stext)stext.textContent=pq+' ITEM'+(pq>1?'S':'')+' · PICK '+need+' MORE';if(sprice)sprice.innerHTML=fmt(totalPence());}
    }

    if(fill){fill.style.width=pct+'%';fill.classList.toggle('is-complete',complete);}
    if(track)track.classList.toggle('is-complete',complete);
    if(addBtn){
      if(canCheckout){
        addBtn.disabled=false;addBtn.classList.add('is-active');addBtn.innerHTML='Add to cart — '+fmt(totalPence());
      } else if(pendingFree){
        addBtn.disabled=true;addBtn.classList.remove('is-active');
        addBtn.innerHTML=giftSVG()+(fq===0?'Add 1 extra free':'Add another free');
      } else if(pq>0){
        addBtn.disabled=true;addBtn.classList.remove('is-active');
        addBtn.innerHTML=giftSVG()+'Pick '+(cfg.tiers[0].buy-pq)+' more to checkout';
      } else {
        addBtn.disabled=true;addBtn.classList.remove('is-active');addBtn.innerHTML='Add to cart — '+fmt(0);
      }
    }
  }

  function buildModal(){
    var tierHTML=cfg.tiers.map(function(t){
      var badge=t.popular?'<span class="si-bb-tier-popular-badge">POPULAR</span>':'';
      var active=t.popular?' is-active':'';
      return '<div class="si-bb-tier-card'+active+'" data-buy="'+t.buy+'">'+badge+'<div class="si-bb-tier-ratio">'+t.buy+'<span>+</span>'+t.free+'</div><div class="si-bb-tier-extra">+'+t.free+' EXTRA FREE</div><div class="si-bb-tier-save">'+fmtSave(t)+'</div></div>';
    }).join('');
    var tabsHTML=cfg.tabs.map(function(tab,i){
      return '<button class="si-bb-tab'+(i===0?' is-active':'')+' " data-handle="'+tab.handle+'">'+tab.label+'</button>';
    }).join('');
    var el=document.createElement('div');
    el.id='si-bb-overlay';el.className='si-bb-overlay';
    el.setAttribute('role','dialog');el.setAttribute('aria-modal','true');el.setAttribute('aria-label','Build your bundle');
    el.innerHTML=
      '<div class="si-bb-modal">'+
        '<div class="si-bb-head">'+
          '<div class="si-bb-head-row"><span class="si-bb-eyebrow">BUNDLE BUILDER</span><button class="si-bb-close" aria-label="Close">×</button></div>'+
          '<h2 class="si-bb-title">Build your bundle.</h2>'+
          '<p class="si-bb-subtitle">Mix any designs. Bigger bundle, bigger save.</p>'+
          '<div class="si-bb-tiers">'+tierHTML+'</div>'+
          '<div class="si-bb-progress">'+
            '<div class="si-bb-progress-row"><span class="si-bb-ptl" id="si-bb-ptl">Pick '+cfg.tiers[0].buy+' items to unlock 1 FREE</span><span class="si-bb-ptr" id="si-bb-ptr"></span></div>'+
            '<div class="si-bb-progress-track"><div class="si-bb-progress-fill" id="si-bb-fill"></div></div>'+
            '<div class="si-bb-price-row" id="si-bb-prow" style="display:none"><span id="si-bb-ptotal"></span><span class="si-bb-psave" id="si-bb-psave"></span></div>'+
          '</div>'+
          '<div class="si-bb-tabs">'+tabsHTML+'</div>'+
        '</div>'+
        '<div class="si-bb-body"><div class="si-bb-grid" id="si-bb-grid"><div class="si-bb-loading">Loading products…</div></div></div>'+
        '<div class="si-bb-footer">'+
          '<div class="si-bb-status-strip" id="si-bb-strip" style="display:none">'+
            '<div class="si-bb-strip-row"><span class="si-bb-strip-text" id="si-bb-stext"></span><button class="si-bb-cancel-link" id="si-bb-cancel">CANCEL</button></div>'+
            '<div class="si-bb-strip-price" id="si-bb-sprice"></div>'+
          '</div>'+
          '<button class="si-bb-add-btn" id="si-bb-add" disabled>Add to cart — '+fmt(0)+'</button>'+
        '</div>'+
      '</div>';
    document.body.appendChild(el);
    bindModalEvents(el);
    nudgeCurrencyApp();
  }

  function openModal(tier){
    if(!document.getElementById('si-bb-overlay'))buildModal();
    var ov=document.getElementById('si-bb-overlay');
    if(tier){ov.querySelectorAll('.si-bb-tier-card').forEach(function(c){c.classList.toggle('is-active',String(c.dataset.buy)===String(tier));});}
    ov.classList.add('is-open');document.body.style.overflow='hidden';
    loadProducts(activeHandle);refreshProgress();nudgeCurrencyApp();
  }

  function closeModal(){var ov=document.getElementById('si-bb-overlay');if(ov)ov.classList.remove('is-open');document.body.style.overflow='';}

  function openCart(){
    document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
    document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true}));
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=cart.item_count;});
      document.querySelectorAll('.cart-count-bubble span:not(.visually-hidden)').forEach(function(el){el.textContent=cart.item_count;});
      document.querySelectorAll('.cart-count-bubble').forEach(function(el){
        if(cart.item_count>0){el.removeAttribute('hidden');el.classList.remove('hidden');}
      });
      if(typeof SLIDECART_UPDATE==='function') SLIDECART_UPDATE();
    });
    setTimeout(function(){
      if(typeof SLIDECART_UPDATE==='function') SLIDECART_UPDATE();
      if(typeof SLIDECART_OPEN==='function'){
        SLIDECART_OPEN();
      } else {
        document.dispatchEvent(new CustomEvent('cart:open',{bubbles:true}));
        var cartDrawer=document.querySelector('cart-drawer');
        if(cartDrawer&&typeof cartDrawer.open==='function') cartDrawer.open();
      }
    },300);
  }

  function addToCart(){
    var btn=document.getElementById('si-bb-add');if(!btn||btn.disabled)return;
    var items=Object.keys(sel).map(function(id){return{id:parseInt(id,10),quantity:1};});
    if(!items.length)return;
    btn.disabled=true;var origHTML=btn.innerHTML;btn.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:items})})
      .then(function(r){if(!r.ok)throw new Error();return r.json();})
      .then(function(){
        sel={};cache={};closeModal();openCart();
      })
      .catch(function(){btn.disabled=false;btn.innerHTML=origHTML;});
  }

  function bindModalEvents(ov){
    ov.addEventListener('click',function(e){if(e.target===ov)closeModal();});
    ov.querySelector('.si-bb-close').addEventListener('click',closeModal);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&ov.classList.contains('is-open'))closeModal();});
    ov.addEventListener('click',function(e){
      var tcard=e.target.closest('.si-bb-tier-card');
      if(tcard){ov.querySelectorAll('.si-bb-tier-card').forEach(function(c){c.classList.remove('is-active');});tcard.classList.add('is-active');return;}
    });
    ov.addEventListener('click',function(e){
      var tab=e.target.closest('.si-bb-tab');
      if(tab){ov.querySelectorAll('.si-bb-tab').forEach(function(t){t.classList.remove('is-active');});tab.classList.add('is-active');activeHandle=tab.dataset.handle;loadProducts(activeHandle);}
    });
    ov.addEventListener('click',function(e){
      var card=e.target.closest('.si-bb-card');if(!card)return;
      if(card.dataset.soldout==='1')return;
      toggleItem(card.dataset.vid,parseInt(card.dataset.pence,10));
    });
    document.getElementById('si-bb-add').addEventListener('click',addToCart);
    var cancelBtn=document.getElementById('si-bb-cancel');if(cancelBtn)cancelBtn.addEventListener('click',closeModal);
  }

  function handleBBClick(e){
    var trigger=e.target.closest('[data-bundle-builder-open]');
    if(trigger)openModal(trigger.dataset.tier||null);
  }
  document.addEventListener('click',handleBBClick);

  document.addEventListener('shopify:section:load',function(){
    ensureStyles();
    window.BundleBuilderLoaded=false;
    document.removeEventListener('click',handleBBClick);
    document.addEventListener('click',handleBBClick);
  });
  document.addEventListener('shopify:section:unload',function(){
    window.BundleBuilderLoaded=false;
  });
})();
